<template>
    <div id="free">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">免费</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>

        <h3>
            限时免费
            <p class="fr">
                <span class="day">{{day}}</span> 天 <span class="time">{{hour}}</span> 时 <span class="time">{{minute}}</span> 分 <span class="time">{{second}}</span> 秒
            </p>
        </h3>
        <el-row :gutter="20" class="freebooklist">
            <el-col :span="8" v-for="item in freeBooks">
                <router-link :to="{name:'Book',params:{wid:item.wid}}">
                    <el-image :src="'http://static.yuread.cn/' + item.h_cover + '@!thumb'" fit="fit" lazy></el-image>
                    <p>{{item.title}}</p>
                </router-link>

            </el-col>

        </el-row>
        <h4>重磅推出</h4>
        <ul class="heavy">
            <router-link v-for="item in zb" tag="li" :to="{name:'Book',params:{wid:item.bookid}}">
                <span class="finish"><img :src="require('./../assets/images/finish' + item.is_finish +'.png')" alt=""></span>
                <el-image :src="'http://static.yuread.cn/' + item.img + '@!thumb'" fit="fit" lazy></el-image>
                <div>
                    <p class="title">{{item.title}}</p>
                    <p class="description">{{item.sort_description}}</p>
                    <p class="author">{{item.author}}</p>
                </div>

            </router-link>

        </ul>
    </div>
</template>

<script>
    export default {
        name: "Free",
        data(){
            return {
                day : 0,
                hour:0,
                minute : 0,
                second : 0,
                freeBooks : [],
                zb:[],
                time : 0,
            }
        },methods:{
            countDown(){

                let end = this.time;
                let start = new Date().getTime();
                var leftTime = end - start;

                //定义变量 d,h,m,s保存倒计时的时间
                if (leftTime >= 0) {
                    this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                    this.hour = Math.floor(leftTime / 1000 / 60 / 60 % 24);
                    this.minute = Math.floor(leftTime / 1000 / 60 % 60);
                    this.second = Math.floor(leftTime / 1000 % 60);
                    setTimeout(this.countDown,1000)
                }

            },
            getFreeList(){
                this.axios.post('/api/free/getFreeList').then(r => {
                    this.freeBooks = r.data.data;
                    this.time = r.data.data[0].end * 1000
                    this.countDown();
                });
            },
            getRecommendList(){
                this.axios.post('/api/recommend/getRecommendList',{
                    rid : 10
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.zb = data.data
                    }

                })
            },
        },
        mounted(){

            this.getFreeList();
            this.getRecommendList()
        }
    }
</script>

<style lang="less">
#free{background: #f6f6f7;
    .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }
    h3{padding: 20px;font-size: 32px;font-weight: 600;background: #fff;
        .fr{font-size: 24px;padding-top: 8px;
            span{background: #333;color: #fff;width:40px;display: inline-block;text-align: center;border-radius: 5px;}
            .day{background: @theme;}
        }
    }
    .freebooklist{margin: 0!important;background: #fff;
        .el-image{height: 280px;}
        img{width:100%;height:100%;box-shadow:0 1px 3px rgba(0,0,0,.3);}
        p{
            overflow: hidden;text-overflow:ellipsis;white-space: nowrap;line-height: 60px;font-size: 28px;color: #333;
        }
        .el-col{margin-bottom: 20px;}
    }
    h4{padding: 20px;margin-top: 20px;background: #fff;font-size: 32px;font-weight: 600;color: #333333;}
    .heavy{padding: 20px;background: #fff;
        li{overflow: auto;border-bottom: 1px solid #efefef;padding: 10px 0;position:relative;
            .el-image{width:120px;height: 160px;float: left;box-shadow: 0 1px 3px rgba(0,0,0,.3);padding: 0;
                img{width: 100%;height: 100%;}

            }
            div{float: left;width:580px; padding-left: 20px;
                p{padding: 5px 0;}
                .title{font-size: 28px;color: #272727;}
                .description{color:#666;font-size: 24px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
                .author{color:#b0b0b0;font-size: 24px;}
            }

            .finish{width:60px;height:60px;position: absolute;top:6px;left:-1px;z-index: 99;
                img{width:100%;height:100%;box-shadow: none;}
            }
        }
    }
}
</style>
